import React from 'react';
import { useTrackableLink } from '@noths/polaris-client-react-hooks';

import * as styles from './AccountPopover.styles';

const getTrackingEventWithLabel = (ev: React.MouseEvent<HTMLAnchorElement>) => ({
  event: 'custom_event',
  event_category: 'Header',
  event_action: 'my account click',
  event_label: ev.currentTarget.textContent?.trim(),
});

interface AccountLinkProps {
  href: string;
  text: string;
}

export const AccountLink = ({ href, text }: AccountLinkProps) => {
  const { trackLinkClick, trackLinkMouseDown } = useTrackableLink();

  return (
    <a
      css={styles.link}
      href={href}
      onClick={trackLinkClick(getTrackingEventWithLabel)}
      onMouseDown={trackLinkMouseDown(getTrackingEventWithLabel)}
    >
      {text}
    </a>
  );
};
